import React from 'react'
import HandleNotification from './Home/HandleNotification';
import HandleFAQ from './Home/HandleFAQ';
import HandleSchedule from './Home/HandleSchedule';

function AdminServices() {
    return (
        <div>
            <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
                <div className='service-container'>
                    <HandleNotification />
                </div>
                <div className='service-container'>
                    <HandleFAQ />
                </div>
            </div>
            <div>
                <div className='service-container'>
                    <HandleSchedule />
                </div>
            </div>
        </div>
    )
}

export default AdminServices;